import { dispatchAction } from '@ardoq/rxbeach';
import type { TraversalLoadedState, TraversalParams } from '@ardoq/api-types';
import { logError } from '@ardoq/logging';
import { loadedStateOperations } from 'loadedState/loadedStateOperations';
import { loadedStateUpdated } from 'loadedState/actions';
import { buildTraversalState, isError } from 'loadedState/buildState';
import { scopeDataLoaded } from 'traversals/stagedLoadedDataAndState$';

export const rebuildTraversalLoadedState = async (
  loadedState: TraversalLoadedState,
  nextParams: TraversalParams
): Promise<boolean> => {
  const loadedGraphOrError = await buildTraversalState(nextParams);
  if (isError(loadedGraphOrError)) {
    logError(
      new Error(loadedGraphOrError.error),
      'Could not rebuild the dataset from its new traversal.'
    );
    return false;
  }

  dispatchAction(scopeDataLoaded({ scopeData: loadedGraphOrError.scopeData }));
  dispatchAction(
    loadedStateUpdated({
      existingHash: loadedStateOperations.stateToHash(loadedState),
      loadedState: loadedStateOperations.attachLoadedGraph(
        { ...loadedState, data: nextParams },
        loadedGraphOrError
      ),
    })
  );
  return true;
};
